module.exports = __webpack_public_path__ + "img/NVR-logo.1ab45a99.png";